import React from 'react';
import { Shield } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#050508] border-t border-[#1e1e2e] py-12" data-id="element-25">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-26">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8" data-id="element-27">
          {/* Brand */}
          <div className="col-span-1" data-id="element-28">
            <div className="flex items-center gap-2 mb-4" data-id="element-29">
              <Shield className="h-6 w-6 text-[#00ff88]" data-id="element-30" />
              <span className="text-xl font-bold tracking-wider text-white font-mono" data-id="element-31">
                IRONKEEP
              </span>
            </div>
            <p className="text-[#a0a0b0] text-sm max-w-xs" data-id="element-32">
              Digital fortress for the modern world. Securing your digital life
              with military-grade encryption and zero-knowledge architecture.
            </p>
          </div>

          {/* Links */}
          <div className="col-span-1 flex justify-center md:justify-start" data-id="element-33">
            <div className="grid grid-cols-2 gap-8" data-id="element-34">
              <div data-id="element-35">
                <h4 className="text-white font-bold font-mono mb-4" data-id="element-36">PRODUCT</h4>
                <ul className="space-y-2 text-sm text-[#a0a0b0]" data-id="element-37">
                  <li data-id="element-38">
                    <a href="#solutions" className="hover:text-[#00ff88] transition-colors" data-id="element-39">
                      Solutions
                    </a>
                  </li>
                  <li data-id="element-40">
                    <a href="#pricing" className="hover:text-[#00ff88] transition-colors" data-id="element-41">
                      Pricing
                    </a>
                  </li>
                  <li data-id="element-42">
                    <a href="#trust" className="hover:text-[#00ff88] transition-colors" data-id="element-43">
                      Trust
                    </a>
                  </li>
                </ul>
              </div>
              <div data-id="element-44">
                <h4 className="text-white font-bold font-mono mb-4" data-id="element-45">COMPANY</h4>
                <ul className="space-y-2 text-sm text-[#a0a0b0]" data-id="element-46">
                  <li data-id="element-47">
                    <a href="#" className="hover:text-[#00ff88] transition-colors" data-id="element-48">
                      About
                    </a>
                  </li>
                  <li data-id="element-49">
                    <a href="#" className="hover:text-[#00ff88] transition-colors" data-id="element-50">
                      Careers
                    </a>
                  </li>
                  <li data-id="element-51">
                    <a href="#" className="hover:text-[#00ff88] transition-colors" data-id="element-52">
                      Contact
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* Address */}
          <div className="col-span-1 md:text-right" data-id="element-53">
            <h4 className="text-white font-bold font-mono mb-4" data-id="element-54">
              HEADQUARTERS
            </h4>
            <p className="text-[#a0a0b0] text-sm" data-id="element-55">
              Ironkeep Ltd.
              <br data-id="element-56" />
              Limassol, Cyprus
            </p>
          </div>
        </div>

        <div className="border-t border-[#1e1e2e] pt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-57">
          <p className="text-[#505060] text-sm font-mono" data-id="element-58">
            © 2026 Ironkeep. All rights reserved.
          </p>
          <div className="flex gap-6" data-id="element-59">
            <a href="#" className="text-[#505060] hover:text-[#00ff88] text-sm transition-colors" data-id="element-60">
              Privacy Policy
            </a>
            <a href="#" className="text-[#505060] hover:text-[#00ff88] text-sm transition-colors" data-id="element-61">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}